import React, { useEffect, useRef } from "react";
import Icon from "../assets/Icon";
import image1 from "../assets/login/Studying-cuate-1.png";
import image2 from "../assets/login/Studying-cuate-2.png";
import image3 from "../assets/login/Studying-cuate-3.png";
import { gsap } from "gsap";

function RegistrationLeftSide({ selectedUserRole }) {
  const images = [image1, image2, image3];
  const imgRefs = useRef([]);
  const mainTextRef = useRef(null);
  const subTextRef = useRef(null);
  const cursorRef = useRef(null);

  const mainTexts = [
    "Learn the skills",
    "Practice with purpose",
    "Ace your interview with confidence",
  ];

  const subTexts = [
    "Build job-ready skills with expert-designed lessons.",
    "Test your knowledge with real-world scenarios.",
    "Practice with AI mock interviews and get real-time insights.",
  ];

  const typeText = (element, text) => {
    if (!element) return;
    element.textContent = "";
    if (cursorRef.current) cursorRef.current.style.display = "inline-block";

    text.split("").forEach((char, i) => {
      gsap.to(
        {},
        {
          duration: 0.1,
          delay: i * 0.05,
          onComplete: () => {
            element.textContent += char;
            // Keep cursor visible while typing
            if (cursorRef.current) cursorRef.current.style.display = "none";
          },
        }
      );
    });

    // Hide cursor after typing (optional)
    gsap.to(cursorRef.current, {
      delay: text.length * 0.05,
      duration: 0,
      onComplete: () => {
        if (cursorRef.current) cursorRef.current.style.display = "none";
      },
    });
  };

  useEffect(() => {
    const tl = gsap.timeline({ repeat: -1 }); // repeat infinitely

    images.forEach((img, index) => {
      // Fade in image
      tl.to(imgRefs.current[index], {
        opacity: 1,
        duration: 1,
        ease: "power1.inOut",
      });

      // Animate main text typing
      tl.call(
        () => {
          if (mainTextRef.current && subTextRef.current) {
            typeText(mainTextRef.current, mainTexts[index]);
            subTextRef.current.textContent = subTexts[index];
          }
          if (cursorRef.current)
            cursorRef.current.style.display = "inline-block"; // reset cursor
        },
        null,
        "-=1"
      );

      // Stay visible for 3 seconds
      tl.to(imgRefs.current[index], {
        opacity: 0,
        duration: 1,
        ease: "power1.inOut",
        delay: 5,
      });

      // Clear text for next loop
      tl.set(mainTextRef.current, { textContent: "" });
      tl.set(subTextRef.current, { textContent: "" });
      tl.set(cursorRef.current, { display: "inline-block" });
    });
  }, []);

  return (
    <>
      <div className="h-screen flex flex-col bg-darkBg">
        {/* Top Section */}
        <div className="  flex items-center justify-start ">
          <div className="px-8 py-4 flex items-center gap-x-2">
            <Icon type="jobdrona-logo" width={35} />
            <span className="font-semibold leading-10 text-[1.2rem] text-orangish">
              JobDrona
            </span>
          </div>
        </div>

        {/* Center Section */}
        <div className="flex-1 px-12  flex flex-col gap-y-8 items-center justify-center">
          {selectedUserRole === "JOBDRONA_CANDIDATE" ? (
            <>
              {/* <div className="px-4 py-2 flex items-center gap-x-2">
                <Icon type="jobdrona-logo" width={49} />
                <span className="font-semibold leading-10 text-4xl text-orangish">
                  JobDrona
                </span>
              </div> */}
              <div className="relative w-full h-64 ">
                {images.map((src, i) => (
                  <img
                    key={i}
                    src={src}
                    alt={`slide-${i}`}
                    ref={(el) => (imgRefs.current[i] = el)}
                    className="absolute top-0 left-0 w-full h-full object-contain opacity-0"
                  />
                ))}
              </div>
              <div className="text-center w-full h-24">
                <span
                  ref={mainTextRef}
                  className="text-orangish text-3xl font-bold text-center"
                ></span>
                <span
                  ref={cursorRef}
                  className=" w-1 h-6 bg-orangish animate-blink"
                ></span>
                <p
                  ref={subTextRef}
                  className="text-white text-lg mt-2 w-full text-center"
                ></p>
              </div>
              <style>{`
        @keyframes blink {
          0%, 50%, 100% { opacity: 1; }
          25%, 75% { opacity: 0; }
        }
        .animate-blink {
          animation: blink 1s step-start infinite;
        }
      `}</style>
            </>
          ) : (
            <div className="flex flex-col text-white">
              <div className="new-left-heading">
                JobDrona <span style={{ color: "#F79009" }}>Advanced </span>
                <span style={{ color: "#F79009" }}> Proctoring</span> Technology
              </div>
              <p className="new-left-sub-heading mt-2">
                Experience unmatched precision and efficiency in parsing and
                matching job descriptions and CVs, irrespective of skills,
                language, or industry. So much more than IT.
              </p>
            </div>
          )}
        </div>

        {/* Bottom Section */}
        <div className=" flex items-center">
          <div className="copyright text-[0.82rem] pb-2 ml-8 flex items-center text-greyish">
            © {new Date().getFullYear()} Copyright JobDrona, India. All rights
            reserved.
          </div>
        </div>
      </div>
    </>
  );
}

export default RegistrationLeftSide;
